<script setup lang="ts">
import { useDiscount } from "@/composables/api/useDiscount";
import { useDotations } from "@/composables/api/useDotations";
import { useReceipts } from "@/composables/api/useReceipts";

import BigDrawCard from "@/components/sections/BigDrawCard.vue";
import BoostBanner from "@/components/sections/BoostBanner.vue";
import GiftsCard from "@/components/sections/gifts-card/GiftsCard.vue";

// Optimize API calls and use cached data because user lands here first.
useReceipts();
useDiscount();
useDotations();
</script>

<template>
  <section class="flex flex-col items-center gap-10 py-10">
    <BoostBanner />

    <GiftsCard />

    <BigDrawCard />
  </section>
</template>
